import { isToday, startOfDay, subDays, subMonths } from 'date-fns';

export type OverviewEventFeedPeriod = '1D' | '3D' | '1W' | '1M';

export const getLocalDateKey = (isoDateStr: string): string => {
  return startOfDay(new Date(isoDateStr)).toISOString().split('T')[0];
};

export const isSameLocalDate = (
  dateStr1: string,
  dateStr2: string
): boolean => {
  return getLocalDateKey(dateStr1) === getLocalDateKey(dateStr2);
};

export const formatDateHeader = (
  dateStr: string,
  t: (key: string) => string
): string => {
  const date = new Date(dateStr);

  if (isToday(date)) {
    return t('whatsNew:today');
  }

  return new Intl.DateTimeFormat(navigator.language, {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  }).format(date);
};

export const getStartDate = (period: OverviewEventFeedPeriod): Date => {
  const start = startOfDay(new Date());

  switch (period) {
    case '1D':
      return subDays(start, 1);
    case '3D':
      return subDays(start, 3);
    case '1W':
      return subDays(start, 7);
    case '1M':
      return subMonths(start, 1);

    default: {
      return subDays(start, 7);
    }
  }
};

export const PERIOD_TITLE_KEY: Record<
  OverviewEventFeedPeriod,
  { key: string; count: number }
> = {
  '1D': { key: 'whatsNew:periodDays', count: 1 },
  '3D': { key: 'whatsNew:periodDays', count: 3 },
  '1W': { key: 'whatsNew:lastWeeks', count: 1 },
  '1M': { key: 'whatsNew:pastMonth', count: 1 },
};
